import { ContactForm } from "components/JsonForm/theme/widgets/ApplicationContactsWidget/ContactForm";
import { PremiseContactFormProps, ContactTypeCode } from "./types";
import { RequireContact } from "types/RequireContact";
import { getHiddenFieldsByContactType, getRequiredFieldsByContactType, ContactType } from "components/utils/contacts";

export const PremiseContactForm = ({
    formData,
    errors,
    requirements,
    onUseCustomerContact,
    onChange,
    onClearForm,
}: PremiseContactFormProps) => {
    const requiredFields = getRequiredFieldsByContactType(requirements.requiredFields, ContactType.Premise);
    const hiddenFields = getHiddenFieldsByContactType(requirements.hiddenFields, ContactType.Premise);

    const hideContact = requirements.requirePremise === RequireContact.Hidden;
    if (hideContact) {
        return null;
    }
    return (
        <ContactForm
            idPrefix="premise-contact"
            formData={formData}
            requirements={requirements}
            requiredFields={requiredFields}
            hiddenFields={hiddenFields}
            errors={errors}
            onUseCustomerContact={onUseCustomerContact}
            onChange={onChange}
            onClearForm={onClearForm}
            contactType={ContactTypeCode.Premise}
        />
    );
};
